import React, { useState, forwardRef } from "react";
import { InputText } from "primereact/inputtext";
import MeaCreateModal from "../../../../components/MeaCreateModal";
import { InputTextarea } from "primereact/inputtextarea";
import levelsAPI from "../../../../services/levels";

const PRESET_COLORS = [
  "#BAE6FD", // Bleu ciel
  "#FED7AA", // Orange
  "#FEF08A", // Jaune
  "#BBF7D0", // Vert
  "#E9D5FF", // Violet clair
  "#FECDD3", // Rose
  "#DDD6FE", // Violet
  "#99F6E4", // Turquoise
  "#FED7D7", // Rouge pastel
  "#E2E8F0", // Gris ardoise
  "#FEF3C7", // Ambre
  "#D1FAE5", // Émeraude
  "#E0E7FF", // Indigo
  "#FCE7F3", // Rose clair
];

const CreateLevelModal = forwardRef((props, ref) => {
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [color, setColor] = useState("#BAE6FD");

  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer un niveau"
        serviceAPI={levelsAPI}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        accessToken={props?.accessToken}
        data={{
          name: name,
          presentation: presentation,
          color: color,
        }}
        onSubmitted={() => {
          setName("");
          setPresentation("");
          setColor("#BAE6FD");
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom du niveau
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <label htmlFor="color" className="block text-900 font-medium mb-2">
          Couleur du niveau
        </label>
        <div className="flex flex-column gap-2 mb-3">
          <div className="flex flex-wrap gap-2 align-items-center">
            {PRESET_COLORS.map((preset) => (
              <button
                key={preset}
                type="button"
                onClick={() => setColor(preset)}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "6px",
                  backgroundColor: preset,
                  border:
                    color?.toLowerCase() === preset.toLowerCase()
                      ? "2.5px solid #000000"
                      : "1px solid #ccc",
                  cursor: "pointer",
                  outline: "none",
                  transform:
                    color?.toLowerCase() === preset.toLowerCase()
                      ? "scale(1.15)"
                      : "scale(1)",
                  transition: "all 0.15s ease",
                }}
              />
            ))}
          </div>
          <div className="flex align-items-center gap-2 mt-2">
            <input
              type="color"
              value={color || "#BAE6FD"}
              onChange={(e) => setColor(e.target.value)}
              style={{
                width: "40px",
                height: "36px",
                padding: "2px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            />
            <InputText
              value={color || ""}
              onChange={(e) => setColor(e.target.value)}
              placeholder="#BAE6FD"
              style={{ width: "120px" }}
            />
          </div>
        </div>
      </MeaCreateModal>
    </>
  );
});

export default CreateLevelModal;
